import { render, staticRenderFns } from "./CompleteText.vue?vue&type=template&id=71a25307&scoped=true&"
import script from "./CompleteText.vue?vue&type=script&lang=js&"
export * from "./CompleteText.vue?vue&type=script&lang=js&"
import style0 from "./CompleteText.vue?vue&type=style&index=0&id=71a25307&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a25307",
  null
  
)

export default component.exports